module.exports = __webpack_public_path__ + "static/8- Cerca de La Puerta Los Dos -close up--9efde10e1beaf9cd3a97902a44ede61f.jpg";